import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchases } from '../data/purchases';

/** Rotating social-proof toast: someone just bought the collection. */
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeoutId: number;
    const show = window.setTimeout(() => setVisible(true), 6000);
    const interval = window.setInterval(() => {
      setVisible(false);
      timeoutId = window.setTimeout(() => {
        setIndex(current => (current + 1) % purchases.length);
        setVisible(true);
      }, 600);
    }, 14000);
    return () => {
      window.clearTimeout(show);
      window.clearInterval(interval);
      window.clearTimeout(timeoutId);
    };
  }, [dismissed]);
  if (dismissed || !visible) return null;
  const purchase = purchases[index];
  return <div role="status" aria-live="polite" className="fixed bottom-3 left-3 z-50 w-[16.5rem] animate-toast-in rounded-lg border-2 border-green bg-steel/95 p-2.5 shadow-xl shadow-black/50 backdrop-blur sm:bottom-5 sm:left-5 sm:w-[19rem]" data-id="element-133" data-mp="1u6rgwjm8tj9t">
      <div className="flex items-start gap-2.5" data-id="element-134" data-mp="237z1jyvu6llf">
        <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-green/20" data-id="element-135" data-mp="286shrz2icqpa">
          <CheckCircle2Icon className="h-4 w-4 text-green" aria-hidden="true" data-id="element-136" data-mp="1bgt27knxwrx7" />
        </span>
        <div className="min-w-0 flex-1" data-id="element-137" data-mp="1fgtpzvwxifgx">
          <p className="text-xs font-bold leading-tight text-white" data-id="element-138" data-mp="1fhuzvx27kvx2">
            {purchase.name} just got METAL FABRICATION READY™
          </p>
          <p className="mt-0.5 text-[0.68rem] font-medium text-lightGray" data-id="element-139" data-mp="1p7y46tes5wap">
            {purchase.city}, {purchase.country} · a few minutes ago
          </p>
        </div>
        <button type="button" onClick={() => setDismissed(true)} aria-label="Close notification" className="rounded p-0.5 text-steelGray transition-colors duration-150 ease-out hover:text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-green/50" data-id="element-140" data-mp="rq6dsyfzd3ok">
          <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-141" data-mp="28ubgao5ypz1h" />
        </button>
      </div>
    </div>;
}